import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileActionBar from "@/components/MobileActionBar";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col overflow-x-hidden bg-[#0A0A0C]">
      <Header />
      <main className="flex-1 pb-20 pt-16 lg:pb-0 xl:pt-[72px]">{children}</main>
      <Footer />
      <MobileActionBar />
    </div>
  );
}
